import { CalendarCheck, Crown, Rocket, TrendingUp } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const steps: { icon: LucideIcon; title: string; body: string }[] = [
  {
    icon: Rocket,
    title: 'Step 1 · Activation',
    body: 'When your friend makes her first sale through Sellyt, ₦500 lands in your wallet instantly. No waiting.',
  },
  {
    icon: TrendingUp,
    title: 'Step 2 · Monthly share',
    body: 'Every month she keeps selling, you keep earning. Up to ₦1,500/month — the more she sells, the more you earn.',
  },
  {
    icon: CalendarCheck,
    title: 'Step 3 · Six months',
    body: "This keeps going for 6 months. That's up to ₦9,000 from one referral, just from her selling the way she already does.",
  },
  {
    icon: Crown,
    title: 'Bonus · Upgrade reward',
    body: 'If she upgrades to a paid Sellyt plan, you earn an extra ₦1,000. One-time bonus on top of everything else.',
  },
];

export const HowItWorks = () => {
  return (
    <div className="how">
      {steps.map((step, index) => {
        const Icon = step.icon;
        return (
          <article key={step.title} className="how-card">
            <span className="ix">0{index + 1}</span>
            <div className="ic">
              <Icon className="size-5" />
            </div>
            <h4>{step.title}</h4>
            <p>{step.body}</p>
          </article>
        );
      })}
    </div>
  );
};
